import React from "react";
import Creatable from "react-select/creatable";
import { FormattedMessage, injectIntl } from "react-intl";
import PropTypes from "prop-types";

import { modalFactory } from "common/components/ModalDialog";

/**
 * Renders a component used to let users interact with their predefined recalls.
 */
function PredefinedRecall(props) {
  // Modal dialog called when user clicks the delete button to confirm they meant to do that.
  const confirmDelete = modalFactory({
    dialog: {
      title: "alpha.confirmDeleteTitle",
      body: "alpha.confirmDeleteBody"
    },
    reject: {
      message: "cancel"
    },
    confirm: {
      message: "delete",
      buttonClass: "danger",
      handler: props.delete
    }
  });

  const updateEnabled = props.selected && props.isModified;
  const deleteEnabled = Boolean(props.selected);

  return (
    <div id="saved-recall">
      <Creatable
        formatCreateLabel={label =>
          props.intl.formatMessage(
            { id: "ReactSelect.CreateLabel" },
            { label: label }
          )
        }
        onChange={props.onChange}
        options={props.list}
        isSearchable={true}
        className="saved-recalls"
        placeholder={<FormattedMessage id="saved_recalls" />}
        isClearable={true}
        isLoading={props.isLoading}
        value={props.selected}
      />
      <span data-tip={props.intl.formatMessage({ id: "update_recall" })}>
        <button
          className="btn btn-success update-button"
          onClick={props.update}
          disabled={!updateEnabled}
        >
          <i className="icon-check" />
        </button>
      </span>
      <span data-tip={props.intl.formatMessage({ id: "delete_recall" })}>
        <button
          className="btn btn-danger delete-button"
          onClick={confirmDelete}
          disabled={!deleteEnabled}
        >
          <i className="icon-trash" />
        </button>
      </span>
    </div>
  );
}

PredefinedRecall.propTypes = {
  // A list of predefined recall objects to present to the user for selection
  list: PropTypes.array.isRequired,
  // The currently selected predefined recall object
  selected: PropTypes.object,
  // True if the current set of picker selections (anything that is saved as part of predefined recall)
  // has changed after the user has selected an existing predefined recall (in other words, is their selection
  // state "dirty")
  isModified: PropTypes.bool.isRequired,
  // True if there is network activity pertaining to saving or retrieving predefined recalls
  isLoading: PropTypes.bool.isRequired,
  // A callback fired when a predefined recall selection has been made, or one has been saved
  onChange: PropTypes.func,
  // A callback when a selected predefined recall has been confirmed to be deleted
  delete: PropTypes.func,
  // i18n object
  intl: PropTypes.object.isRequired
};

PredefinedRecall.defaultProps = {
  selected: null
};

export default injectIntl(PredefinedRecall);
